module.exports = __webpack_public_path__ + "img/farm_Uganda.f9db16a6.jpg";